import { Card, Skeleton } from "antd";

const ContentScalaton = () => {
  return (
    <Card>
      <Skeleton active paragraph={{ rows: 4 }} />
      <Skeleton active paragraph={{ rows: 2 }} />
      <Skeleton active paragraph={{ rows: 3 }} />
    </Card>
  );
};

export default ContentScalaton;